import React from 'react'
import PropTypes from 'prop-types'

import SVG from '../SVG/SVG'
import { createUseStyles } from 'react-jss'
import _ from 'lodash'

const useStyles = createUseStyles(theme => ({
  locationHeader: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: 0,
    padding: 0,
  },
  locationTitleCon: {
    display: 'block',
    // backgroundColor: theme.colors.blue,
    backgroundColor: theme.colors.deepsea,
    // backgroundColor: theme.colors.lightblue,
    color: theme.colors.white,
    width: '100%',
    margin: 0,
    padding: 0,

    '& h1': {
      margin: '20px 0',
      padding: '10px 0',
      color: theme.colors.white,
      fontFamily: theme.fontFamily,
      fontWeight: 900,
      fontSize: 40,
      letterSpacing: 0.6,
      lineHeight: 1.5,
      wordSpacing: 1.8,
      textAlign: 'left',
    },
  },
  locationDetailsCon: {
    display: 'block',
    backgroundColor: theme.colors.yellow,
    color: theme.colors.black,
    width: '100%',
    padding: '10px 0',
  },
  wrapper: {
    maxWidth: 1490,
    padding: '0 25px',
    margin: '0 auto',
    boxSizing: 'border-box',
  },
  locationAddressCon: {
    display: 'flex',
    flexDirection: 'row',
    // paddingBottom: 10,

    '@media (max-width: 900px)': {
      flexDirection: 'column',
    },

    '& a': {
      marginLeft: 20,
      padding: 10,
      backgroundColor: theme.colors.yellow,
      borderRadius: theme.borderRadius,
      textDecoration: 'none',
      color: theme.colors.blue,
      fontWeight: 500,
      height: 20,
      maxWidth: 150,

      '@media (max-width: 900px)': {
        margin: '0 auto 20px',
      },
    },
    '& a:hover': {
      backgroundColor: theme.colors.sunflower,
    },
  },
  locationAddress: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 10,
  },
  locationAddressText: {
    margin: '0 0 30px 0',

    '& p': {
      margin: '10px 0 0',
      padding: 0,
      fontFamily: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit',
    },

    '@media (max-width: 900px)': {
      margin: '0 0 10px 0',
    },
  },
  locationAddressMarker: {
    margin: '10px 10px 0 0',
  },
  locationContact: {
    display: 'flex',
    flexDirection: 'row',
    padding: '10px 0',
    justifyContent: 'space-between',

    '@media (max-width: 900px)': {
      flexDirection: 'column',
      padding: 0,
    },
  },
  locationHours: {
    display: 'flex',
    padding: '10px 0',

    '@media (max-width: 900px)': {
      padding: 0,
    },
  },
  detailsItem: {
    display: 'flex',
    flexDirection: 'row',
    fontWeight: 500,
    padding: 0,

    '@media (max-width: 900px)': {
      padding: '10px 0',
    },

    '& span': {
      fontWeight: 900,
      color: theme.colors.blue,
      marginRight: 20,
    },

    '& a': {
      color: theme.colors.black,
      textDecoration: 'none',
    },
    '& a:hover': {
      color: theme.colors.blue,
      textDecoration: 'underline',
    },
  },
}))

export const LocationHeader = ({ location }) => {
  const classes = useStyles()

  const LOCAL_STORE_SCHEMA = {
    '@context': 'http://schema.org',
    '@type': 'LocalBusiness',
    image:
      location.country === 'au'
        ? 'https://www.acerentalcars.com.au/themes/acerte/assets/images/logoau.jpeg'
        : 'https://www.acerentalcars.co.nz/themes/acerte/assets/images/logonz.jpeg',
    address: {
      '@type': 'PostalAddress',
      addressCountry: location.country.toUpperCase(),
      addressLocality: location.gs_city,
      addressRegion: location.gs_region,
      postalCode: location.gs_postcode,
      streetAddress: location.gs_street_address,
    },
    description: location.gs_description,
    name: location.gs_name,
    telephone: location.gs_telephone,
    openingHours: location.gs_opening_hours,
    priceRange: location.gs_price_range,
    geo: {
      '@type': 'GeoCoordinates',
      latitude: location.gs_location_latitude,
      longitude: location.gs_location_longitude,
    },
    sameAs: [
      location.country === 'au'
        ? 'https://www.facebook.com/AceRentalCarsAU'
        : 'https://facebook.com/AceRentalCars',
      location.country === 'au'
        ? 'https://www.instagram.com/acerentalcarsau/'
        : 'https://www.instagram.com/acerentalcarsnz',
    ],
  }

  const AUTO_RENTAL_SCHEMA = {
    '@context': 'http://schema.org/',
    '@type': 'AutoRental',
    name: 'ACE Rental Cards',
    openingHours: location.gs_opening_hours,
    paymentAccepted: location.gs_accepted_payments,
    priceRange: location.gs_price_range,
    image:
      location.country === 'au'
        ? 'https://www.acerentalcars.com.au/themes/acerte/assets/images/logoau.jpeg'
        : 'https://www.acerentalcars.co.nz/themes/acerte/assets/images/logonz.jpeg',
    address: {
      '@type': 'PostalAddress',
      addressCountry: location.country.toUpperCase(),
      addressLocality: location.gs_city,
      addressRegion: location.gs_region,
      postalCode: location.gs_postcode,
      streetAddress: location.gs_street_address,

      email: location.gs_email,
      telephone: location.gs_telephone,
      mainEntityOfPage:
        location.country === 'au'
          ? 'https://www.acerentalcars.com.au/'
          : 'https://www.acerentalcars.co.nz/',
      name: 'ACE Rental Cards',
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      reviewCount: location.gs_review_count,
      bestRating: location.gs_best_rating,
      ratingValue: location.gs_rating_value,
    },
  }

  return (
    <div className={classes.locationHeader}>
      {!_.isEmpty(location) ? (
        <React.Fragment>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(LOCAL_STORE_SCHEMA) }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(AUTO_RENTAL_SCHEMA) }}
          />
          <div className={classes.locationTitleCon}>
            <div className={classes.wrapper}>
              <h1>{location.label}</h1>
              <div className={classes.locationAddressCon}>
                <div className={classes.locationAddress}>
                  <div className={classes.locationAddressMarker}>
                    <SVG name={'MapMarkerPlain'} height={20} width={15} colorOne={'#f6c414'} />
                  </div>
                  <div className={classes.locationAddressText}>
                    <p>{location.address}</p>
                  </div>
                </div>
                {/*{*/}
                {/*    !_.isEmpty(location.map_location) ?*/}
                {/*        <a data-lity={""} href={`https://www.google.com/maps/@${JSON.parse(location.map_location).lat},${JSON.parse(location.map_location).lng},16z`}>Get Directions</a>*/}
                {/*    :   ""*/}
                {/*}*/}
                {!_.isEmpty(location.map_link) ? (
                  <a data-lity={''} href={location.map_link}>
                    Get Directions
                  </a>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
          <div className={classes.locationDetailsCon}>
            <div className={classes.wrapper}>
              <div className={classes.locationContact}>
                <div className={classes.detailsItem}>
                  <span>FREE PHONE:</span>
                  <a href={`tel:${location.toll_free}`}>{location.toll_free}</a>
                </div>
                <div className={classes.detailsItem}>
                  <span>PHONE:</span>
                  <a href={`tel:${location.phone}`}>{location.phone}</a>
                </div>
                {/* <div className={classes.detailsItem}>
                  <span>EMAIL:</span>
                  <a href={`mailto:${location.email}`}>{location.email}</a>
                </div> */}
              </div>
              <div className={classes.locationHours}>
                <div className={classes.detailsItem}>
                  <span>OFFICE HOURS:</span>
                  {location.office_hours}
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        ''
      )}
    </div>
  )
}

// LocationHeader.propTypes = {
//   location: PropTypes.string,
// }

export default LocationHeader
